import styled from "styled-components";
import Sidebar from "../Componentes/Utils/Sidebar";
import SidebarButton from "../Componentes/Utils/SidebarButton";
import { NavLink, Outlet } from "react-router-dom";

const Container = styled.div`
    width: 100%;
    height: 100dvh;
    display: flex;
    background-color: red;
`
const Content = styled.div`
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

const Controladoria = () => {
    return (
        <>
            <Container>
                <Sidebar>
                    <NavLink to="/modulo/controladoria/pedidos-compra">
                        {({ isActive }) => (
                            <SidebarButton
                                title="Pedidos de Compra"
                                active={ isActive }
                            />
                        )}
                    </NavLink>
                    <NavLink to="/modulo/controladoria/itens-pedidos-compra">
                        {({ isActive }) => (
                            <SidebarButton
                                title="Itens Pedidos de Compra"
                                active={ isActive }
                            />
                        )}
                    </NavLink>
                    <NavLink to="/modulo/controladoria/nfs-pendentes">
                        {({ isActive }) => (
                            <SidebarButton
                                title="NFs Pendentes"
                                active={ isActive }
                            />
                        )}
                    </NavLink>
                    <NavLink to="/modulo/controladoria/consulta-nfs">
                        {({ isActive }) => (
                            <SidebarButton
                                title="Consulta de NFs"
                                active={ isActive }
                            />
                        )}
                    </NavLink>
                </Sidebar>
                <Content>
                    <Outlet />
                </Content>
            </Container>
        </>
    )
}

export default Controladoria;